module.exports = __webpack_public_path__ + "static/media/th.9ae11930.svg";